import { createContext } from "react";

export const VolumeChangedContext = createContext<boolean>(false);
